import { middlewareAdmin, MiddlewareAdmin, reducersAdmin, ReducersAdmin } from '../reducers-admin'
import { middlewareCommon, reducersCommon, ReducersCommon, setUser } from '../reducers-common'
import { middlewareFund, MiddlewareFund, reducersFund, ReducersFund } from '../reducers-fund'
import { middlewareInvestors, MiddlewareInvestors, reducersInvestors, ReducersInvestors } from '../reducers-investors'

export { middlewareCommon, middlewareFund, middlewareInvestors }
const app = import.meta.env.VITE_APP

export type ReducersApp = {
  admin: ReducersAdmin
  funds: ReducersFund
  investors: ReducersInvestors
}

type MiddlewareApp = {
  admin: MiddlewareAdmin
  funds: MiddlewareFund
  investors: MiddlewareInvestors
}

const reducersApp: ReducersApp = {
  admin: reducersAdmin,
  funds: reducersFund,
  investors: reducersInvestors,
}

export const middlewareApp: MiddlewareApp = {
  admin: middlewareAdmin,
  funds: middlewareFund,
  investors: middlewareInvestors,
}

export const reducers = {
  ...reducersCommon,
  ...reducersApp[app],
} as ReducersCommon & ReducersFund & ReducersAdmin & ReducersInvestors

export { setUser }
